import { Constants } from '../../app/utils/Constants';
import { PERMISSIONS } from '../../app/utils/Permissions';

const P = PERMISSIONS.USINA;

export default {
	header: {
		self: {},
		items: [
			{
				title: "Suporte via WhatsApp",
				root: true,
				alignment: "left",
				link: Constants.whatsappLink,
				icon: "fab fa-whatsapp",
			},
		]
	},
	aside: {
		self: {},
		items: [
			{
				title: "Agendamentos",
				root: true,
				icon: "fas fa-calendar",
				page: "transportador/usina/agendamento",
				permission: P.USINA_CHEGADA_LIST,
				bullet: "dot"
			},
			{
				title: "Cadastrar Motorista",
				root: true,
				icon: "fas fa-plus",
				page: "transportador/usina/motorista",
				permission: P.USINA_MOTORISTA_CREATE,
				bullet: "dot"
			},
		]
	}
};
